import React, { useRef } from 'react'
import { Link, Typography, styled } from '@mui/material'
import { Skeleton } from '@mui/material'
import { isNilOrEmpty } from 'packages/core'
import { Avatar, Dropdown, Tooltip } from '../../eid-ui'
import { DefaultAvatarIcon } from '../../eid-icons'

const centerStyles = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
}

const DropdownAnchor = styled('span')(({ anchorPosition }) => ({
    position: 'relative',
    top: '5.2rem',
    left: '5.4rem !important',
    ...anchorPosition,
}))

const ProfileName = styled(Typography)(({ theme }) => ({
    fontSize: '1.4rem',
    color: '#919193',
    paddingLeft: '0.8rem',
    maxWidth: '15rem',
    overflow: 'hidden',
    [theme.breakpoints.down('md')]: {
        display: 'none',
    },
}))

const AccountDropdown = ({
    loading,
    friendlyName,
    imageUrl,
    anchorPosition,
    style,
    children,
    showCone = true,
    open,
    handleOpen: setOpen,
    disableImage = false,
}) => {
    const anchorRef = useRef(null)

    const handleClose = (event) => {
        if (anchorRef.current && anchorRef.current.contains(event.target)) {
            return
        }

        setOpen(false)
    }

    const handleListKeyDown = (event) => {
        if (event.key === 'Escape') {
            event.preventDefault()
            setOpen(false)
            if (anchorRef.current) {
                anchorRef.current.focus()
            }
        }
    }

    const avatarProps = {
        size: 'small',
        src: imageUrl,
    }

    const userAvatar = (
        <div style={{ ...centerStyles }}>
            {!disableImage && <Avatar {...avatarProps} />}
            {friendlyName && <ProfileName noWrap>{friendlyName}</ProfileName>}
        </div>
    )

    return (
        <>
            <div style={{ position: 'relative', ...centerStyles, ...style }}>
                {loading ? (
                    <Skeleton variant="circular" width={30} height={30} />
                ) : (
                    <Tooltip title={friendlyName ? friendlyName : ''}>
                        <Link
                            sx={{ ...centerStyles }}
                            underline="none"
                            component="button"
                            onClick={() => setOpen((prev) => !prev)}
                        >
                            <DropdownAnchor
                                ref={anchorRef}
                                anchorPosition={anchorPosition}
                            />
                            {isNilOrEmpty(imageUrl) ? (
                                <DefaultAvatarIcon />
                            ) : (
                                userAvatar
                            )}
                        </Link>
                    </Tooltip>
                )}
            </div>

            <Dropdown
                open={open}
                anchorEl={anchorRef.current}
                handleClose={handleClose}
                handleListKeyDown={handleListKeyDown}
                showCone={showCone}
                menuHeight="calc(98vh - 14rem)"
                menuHeightSm="calc(90vh - 17rem)"
            >
                {children}
            </Dropdown>
        </>
    )
}

export default AccountDropdown
